import {Component, Input} from "@angular/core";
import {Location} from "@angular/common";
import {MapService} from "../../services/map.service";
import {Map, MouseEvent, Marker} from "leaflet";
import { Router, ActivatedRoute, Params } from "@angular/router";
import {MdDialogRef} from "@angular/material";

import {Spot, Guide, Category} from "../../core/model";
import {GuideService} from "../../services/guide.service";

@Component({
  selector: "spot-details",
  template: require<any>("./spot-details.component.html"),
  styles: [
    require<any>("../../styles/main.less"),
    require<any>("../../styles/material.theme.scss"),
    require<any>("./spot-details.component.less"),
  ]
})
export class SpotDetailsComponent {

  private navigationLink = "#";
  private spot: any = {};

  constructor(private location: Location, private route: ActivatedRoute, private router: Router, private guideService: GuideService) {
    this.spot.category = {};
  }

  ngOnInit() {
    this.guideService.getActiveGuide().then(guide => {
      this.route.params.subscribe(params => {
        this.showSpotDetails(guide, params['id']);
      });
    });
  }

  back() {
    this.router.navigate(["/"]);
  }


  public showOnMap() {
    this.router.navigate(["/map", this.spot._id]);
  }

  public setLinkToGoogleMaps() {
    let latlng = this.spot.geolocation.geometry.coordinates;
    let latlngRevers = latlng[1] + "," + latlng[0];
    this.navigationLink = "http://maps.google.de/maps?q=" + latlngRevers + "&t=k&z=19";
  }

  showSpotDetails(guide: Guide, spotId) {
    guide.spots.forEach(spot => {
      if (spot._id == spotId) {
        this.spot = spot;
        this.setLinkToGoogleMaps();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/spot-details/spot-details.component.ts